import { Navigate, useParams } from 'react-router-dom';

import { useGetActivo } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveActivos } from '../../shared/saveActivos';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateActivosPageInterface {}

const UpdateActivosPage: React.FC<UpdateActivosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_activo);
  const { id } = useParams();
  const { data, isLoading } = useGetActivo(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_activo) return <Navigate to="/activos/activos" />;

  return (
    <SaveActivos titlePage="Editar Activos" editActivos={data.data} />
  );
};

export default UpdateActivosPage;
